import { tools } from './../helpers/tools';
import { geo } from './../helpers/google';
import { settings } from './../settings';
import { googleMapStyles } from './../helpers/googleMapStyle';

class Geo {
    constructor(underscore) {
        this._ = underscore;
        this.googleApi = null;
        this.currentLocation = null;
        this.locationPermissionGranted = false;
        this.clinics = [];
        this.maxNoOfNearby = 5;
    }

    init(googleApi, resources) {
        this.googleApi = googleApi;
        geo.init(googleApi, resources);
    }

    showHideNearByClinic(hd_our_clinics_nearby, hd_our_clinics_map, hd_our_clinics_price) {
        if (hd_our_clinics_nearby.hasClass('btn-secondary')) {
            hd_our_clinics_nearby.removeClass('btn-secondary');

            $('#hd_nearby_card').hide(300);

            return;
        }

        $('#hd_map_info, #hd_map').hide(300);
        $('#hd_nearby_card').show(300);

        hd_our_clinics_nearby.addClass('btn-secondary');
        hd_our_clinics_map.removeClass('btn-secondary');
        hd_our_clinics_price.removeClass('btn-secondary');

        $('#accordion, #accordion-multi, #accordion-nearby, #hd_our_clinics_title').show(300);
        $('#hd_map_pricelist_container, #hd_our_clinics_title_pricelist').hide();

        tools.trackView('närheten', $('#hd_our_clinics_nearby').text());
    }

    load(clinics, maxNoOfNearby) {
        const self = this;
        self.clinics = clinics;
        self.maxNoOfNearby = maxNoOfNearby;
        if (navigator.permissions) {
            navigator.permissions.query({
                name: 'geolocation',
            }).then(function (result) {
                if (result.state == 'granted') {
                    self.locationPermissionGranted = true;
                }
                self.loadClinics(self.clinics, self.maxNoOfNearby, true);
                // result.onchange = function () {
                //     if (result.state == 'granted') {
                //         self.locationPermissionGranted = true;
                //         self.loadClinics(self.clinics, self.maxNoOfNearby, false);
                //     }
                // }
            });
        } else {
            self.loadClinics(self.clinics, self.maxNoOfNearby, true);
        }

    }

    loadClinics(clinics, maxNoOfNearby, bindClicks) {
        const self = this;

        let map,
            hd_map = $('#hd_map');

        map = geo.map.create(hd_map[0], googleMapStyles.blackAndWhite);

        const hd_our_clinics_nearby = $('#hd_our_clinics_nearby'),
            hd_our_clinics_map = $('#hd_our_clinics_map'),
            hd_our_clinics_price = $('#hd_our_clinics_price'),
            hd_nearby = $('#hd_nearby');

        if (settings.settings.regions && settings.settings.regions.length > 0) {
            self.addRegions(clinics);
            $('.clinic-accordion .collapse')
                .first()
                .collapse('show');

            self.calculateDistances(settings.settings.regions, regions => {
                if (regions) {
                    settings.settings.regions = regions;
                }

                self.region = settings.settings.regions[0];

                self.calculateDistances(clinics, (result, loc) => {
                    if (loc) {
                        geo.map.bounds.extend(loc);
                        geo.map.markCurrentLocation(map, loc);
                        hd_our_clinics_nearby.show();
                    }

                    if (result) {
                        clinics = result;
                    }

                    self.addRegions(clinics);

                    if (self.region) {
                        $(`#collapse-${self.region.city}`).collapse('show');
                    }

                    hd_nearby.html('');
                    clinics.forEach((clinic, index) => {
                        // Need to be defined or else templates will fail
                        if (!clinic.distance) clinic.distance = null;

                        geo.map.markLocation(map, clinic.location, () => {
                            self.markerCallback(map, clinic, clinics);
                        });

                        if (loc && index < maxNoOfNearby) {
                            const html = self._.template($('#tmpl-hd-clinic-row').html())(clinic);
                            hd_nearby.append(html);
                        }
                    });
                });
            });
        }
        if (!bindClicks) {
            return true;
        }
        hd_our_clinics_nearby.click(e => {
            e.preventDefault();
            if (self.locationPermissionGranted) {
                self.showHideNearByClinic(hd_our_clinics_nearby, hd_our_clinics_map, hd_our_clinics_price);
            } else {
                geo.location.getCurrent().then((loc) => {
                    self.locationPermissionGranted = true;
                    self.setLocation(loc);
                    self.loadClinics(self.clinics, self.maxNoOfNearby, false);
                    setTimeout(() => {
                        self.showHideNearByClinic(hd_our_clinics_nearby, hd_our_clinics_map, hd_our_clinics_price);
                    }, 500);
                }).catch(() => {
                })
            }

        });

        hd_our_clinics_map.click(e => {
            e.preventDefault();

            if (!self.locationPermissionGranted) {
                geo.location.getCurrent().then((loc) => {
                    self.locationPermissionGranted = true;
                    self.setLocation(loc);
                    self.loadClinics(self.clinics, self.maxNoOfNearby, false);
                }).catch(() => {
                });
            }
            if (hd_our_clinics_map.hasClass('btn-secondary')) {
                hd_our_clinics_map.removeClass('btn-secondary');

                $('#hd_map_info, #hd_map').hide(300);

                return;
            }

            $('#hd_map_col')
                .removeClass('col-sm-6')
                .addClass('col-sm-12');

            $('#hd_map').show(300, () => {
                geo.map.fitBounds(map, clinics);
            });

            $('#hd_nearby_card').hide(300);

            hd_our_clinics_nearby.removeClass('btn-secondary');
            hd_our_clinics_map.addClass('btn-secondary');
            hd_our_clinics_price.removeClass('btn-secondary');

            $('#accordion, #accordion-multi, #accordion-nearby, #hd_our_clinics_title').show(300);
            $('#hd_map_pricelist_container, #hd_our_clinics_title_pricelist').hide();

            tools.trackView('karta', $('#hd_our_clinics_map').text());
        });

        hd_our_clinics_price.click(e => {
            e.preventDefault();

            if (hd_our_clinics_price.hasClass('btn-secondary')) {
                hd_our_clinics_price.removeClass('btn-secondary');

                $('#accordion, #accordion-multi, #accordion-nearby, #hd_our_clinics_title').show();
                $('#hd_map_pricelist_container, #hd_our_clinics_title_pricelist').hide();
            } else {
                $('#hd_map_info, #hd_map, #hd_nearby_card').hide(300);

                hd_our_clinics_nearby.removeClass('btn-secondary');
                hd_our_clinics_map.removeClass('btn-secondary');
                hd_our_clinics_price.addClass('btn-secondary');

                $('#accordion, #accordion-multi, #accordion-nearby, #hd_our_clinics_title').hide();
                $('#hd_map_pricelist_container, #hd_our_clinics_title_pricelist').show(300);

                tools.trackView('prislista', $('#hd_our_clinics_price').text());
            }
        });
    }

    addRegions(clinics) {
        const container = $('#accordion-multi'),
            template = self._.template($('#tmpl-hd-region').html());

        container.html('');
        settings.settings.regions.forEach(region => {
            let hasclinics = false;

            region.clinics.forEach(clinic => {
                const cl = tools.findByValue(clinics, 'id', clinic.id);
                if (cl && cl.title) {
                    clinic = $.extend(clinic, cl);
                    hasclinics = true;
                }
            });

            if (hasclinics) {
                container.append(template(region));
            }
        });
    }

    markerCallback(map, clinic, clinics) {
        const self = this;

        const hd_map_info = $('#hd_map_info'),
            hd_map_col = $('#hd_map_col'),
            bounds = new self.googleApi.maps.LatLngBounds(),
            openingtemplate = self._.template($('#tmpl-hd-clinic-details-opening').html()),
            detailstemplate = self._.template($('#tmpl-hd-clinic-details').html());

        bounds.extend(clinic.location);

        self.googleApi.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            if (map.getZoom() > 15) {
                map.setZoom(15);
            }
        });

        map.fitBounds(bounds);

        clinic.opening_templated = '';
        clinic.opening_hours.forEach(h => {
            clinic.opening_templated += openingtemplate(h);
        });

        hd_map_info.html(detailstemplate(clinic));

        $('#hd_map_info_close').click(e => {
            e.preventDefault();

            $('#hd_map_info').hide(300, () => {
                $('#hd_map_col')
                    .removeClass('col-sm-6')
                    .addClass('col-sm-12');

                geo.map.fitBounds(map, clinics);
            });
        });

        hd_map_info.show(300);
        hd_map_col.removeClass('col-sm-12').addClass('col-sm-6');
    }

    metersToKm(distance) {
        return distance ? (Math.round(distance / 100) / 10).toString().replace('.', ',') : '-';
    }

    setLocation(loc) {
        this.currentLocation = loc;
    }

    calculateDistances(items, callback) {
        const self = this;
        let pos;

        pos = self.currentLocation ? Promise.resolve(self.currentLocation) : self.locationPermissionGranted ? geo.location.getCurrent() : Promise.reject("location not granted");
        pos.then(
            loc => {
                for (let i = 0; i < items.length; i++) {
                    if (items[i].location) {
                        items[i].distance = geo.geo.calculateDistance(loc, items[i]);
                        items[i].origin = `&origin=${loc.lat()},${loc.lng()}`;
                    }
                }

                items.sort((a, b) => {
                    return a.distance - b.distance;
                });

                if (typeof callback === 'function') {
                    callback(items, loc);
                }
            },
            () => {
                if (typeof callback === 'function') {
                    callback();
                }
            }
        );
    }

    // geocodeClinics(clinics, maxNoOfNearby, callback) {
    //     let pos;

    //     pos = this.currentLocation ? Promise.resolve(this.currentLocation) : geo.location.getCurrent();
    //     pos.then(function (loc) {
    //         for (let i = 0; i < clinics.length; i++) {
    //             if (clinics[i].location) {
    //                 clinics[i].distance = geo.geo.calculateDistance(loc, clinics[i]);
    //             }
    //         }

    //         clinics.sort(function (a, b) {
    //             return a.distance - b.distance;
    //         });

    //         if (typeof callback === 'function') {
    //             callback(clinics, loc);
    //         }
    //     }, function (err) {
    //         console.log(err);

    //         if (typeof callback === 'function') {
    //             callback();
    //         }
    //     });
    // }
}

(function (hd, _) {
    hd.views = hd.views || {};
    hd.views.geo = new Geo(_);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);


// WEBPACK FOOTER //
// ./scripts/booking/views/geo.js